// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__llagV","info":"Footer_info__0fxjH","footerbeskrivning":"Footer_footerbeskrivning__VPwur","contact":"Footer_contact__jw90Y"};